import type React from 'react';
import type { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';
import Navbar from 'app/ui/components/atoms/navbar';
import Footer from 'app/ui/components/atoms/footer';
import HtmlTitle from 'app/ui/components/atoms/html-title';

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Wrapper = styled.div`
  margin: 0 auto 5rem;
  flex: 1;
  width: 100%;

  // Add styles for different device sizes
  ${({ theme: { media } }) => {
    return `
        ${media.small(
          () => `
            padding: 0 2.1875rem;
            `,
        )}
        ${media.large(
          () => `
            max-width: 67.5rem;
          `,
        )}
        `;
  }}
`;

type GenericPageProps = {
  pageTitle: string;
  children: ReactNode;
};

const GenericPage: React.FC<GenericPageProps> = ({ children, pageTitle }) => {
  return (
    <PageContainer>
      <HtmlTitle title={pageTitle} />
      <Navbar />
      <Wrapper>{children}</Wrapper>
      <Footer />
    </PageContainer>
  );
};

export { Navbar, Footer, Wrapper, PageContainer, HtmlTitle };

export default GenericPage;
